import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ManualService {

  constructor(private http: HttpClient) {}

    private apiUrl = `${environment.apiUrl}`;
    private url: string = this.apiUrl + 'api/pdf'; 

  downloadManual(type: string): Observable<Blob> {
        return this.http.get(`${this.url}/manuals/${type}`, {
        responseType: 'blob'
        });
    }
}